import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2),
    },
  },
  schedule_root: {
    width: '100%',
  },
  schedule_details: {
    display: 'block',
  },
  schedule_header: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  schedule_subHeader: {
    marginBottom: theme.spacing(1),
  },
  schedule_sectionContainer: {
    width: '100%',
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '10px',
    marginBottom: theme.spacing(3),
  },
  table_headerText: {
    fontSize: '18px',
  },
  table_row: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  table_expandCaret: {
    width: '5%',
  },
  text: {
    fontSize: '16px',
    marginLeft: '5%',
  },
  provisionSelector: {
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    width: '100%',
  },
  header: {
    fontFamily: 'Roboto',
    padding: '5px',
    paddingLeft: '15px',
    backgroundColor: '#DCDCDC',
  },
  button: {
    margin: theme.spacing(1.5),
    width: '200px',
  },
  alert: {
    marginTop: theme.spacing(1.5),
  },
});
